export const URL_SEARCH_PARAMS = {
    Code: "code",
    Type: "type",
    Hint: "hint",
    Step: "step",
    Action: "action",
    Id: "id",
    DomainKey: "domainkey"
}